import React, {useState} from "react";
import ModernShell from "../../components/ModernShell";
import GamesWithoutRefs from "../../components/GamesWithoutRefs";
import AssignerOrgStats from "../../components/AssignerOrgStats";
import AssignerRefAlignPay from "../../components/AssignerRefAlignPay";
import RefereeRequests from "../../components/RefereeRequests";
import { useAppContext } from "../../context/MainContext/AppContext";
import { filterOrgStats, filterGamesWithoutRefs } from "../../utils/filterGamesData";
import GameAssignModal from "../../components/Modals/GameAssignModal";


const AssignerDashboard = () => {
  const { AssignerGameData, alterPosition, getAvailableReferees } = useAppContext();
  const [isAssignRefereeModalOpen, setIsAssignRefereeModalOpen] = useState(false);
  const [availableReferees, setAvailableReferees] = useState([]);
  const [currentGameData, setCurrentGameData] = useState();

  const openGameAssignModal = async ({ game, positionID }) => {
    setAvailableReferees(await getAvailableReferees(game.GID));
    setCurrentGameData({ ...game, positionID });
    setIsAssignRefereeModalOpen(true);
  };

  const assignRefereeToGame = ({ referee, currentGameData }) => {
    alterPosition({
      PID: currentGameData.positionID,
      UID: referee.UID,
      Status: "Pending",
    });
    setIsAssignRefereeModalOpen(false);
  };

  let filteredOrgStats = [];
  let filteredGamesWithoutRefs = [];

  if (AssignerGameData) {
    filteredOrgStats = filterOrgStats(AssignerGameData);
    filteredGamesWithoutRefs = filterGamesWithoutRefs(AssignerGameData)
  }

  return (
    <ModernShell title="Assigner dashboard" subtitle="Manage games, referees, and payments from one place.">
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <AssignerOrgStats apidata={filteredOrgStats} className="flex-shrink" />
          <GamesWithoutRefs apidata={filteredGamesWithoutRefs} openGameAssignModal={openGameAssignModal} className="flex-shrink" />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <AssignerRefAlignPay className="flex-shrink" />
          <RefereeRequests className="flex-shrink" />
        </div>
      </div>
      <GameAssignModal
          isOpen={isAssignRefereeModalOpen}
          onClose={() => setIsAssignRefereeModalOpen(false)}
          assignRefereeToGame={assignRefereeToGame}
          availableReferees={availableReferees}
          currentGameData={currentGameData}
      />
    </ModernShell>
  );
};

export default AssignerDashboard;
